import { useUserData } from '@/hooks/user/useUserInfo'
import avatarImg from './assets/avatar.png'
import ChevronRightIcon from '@/views/assets/chevron-right.svg'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { useCommon } from '@/core/useCommon'
import { ROUTES } from '@/env/routes'
import { logout } from '@/store/user/useUserStore'

// 使用者資訊
const UserData = () => {
  const { userInfo, myAgent } = useUserData()
  const { t, push } = useCommon()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex cursor-pointer gap-4 sm:w-full sm:flex-row-reverse sm:justify-end sm:gap-10">
        {/* 按鈕 */}
        <div className="flex flex-col justify-center text-right sm:text-left">
          <div className="text-12 sm:text-18 leading-14 font-medium text-[#0D2245] sm:leading-25 sm:text-[#FEFEFE]">{userInfo?.userName}</div>

          <div className="text-12 flex justify-end gap-10 leading-17 text-[#6D7693] capitalize sm:justify-start sm:text-[#e9e9e9]">
            <div>{myAgent}</div>
            <div className="hidden rotate-90 items-center sm:flex">
              <ChevronRightIcon className="size-10" />
            </div>
          </div>
        </div>

        <img src={avatarImg} className="size-32 rounded-full sm:size-50" />
      </DropdownMenuTrigger>

      {/* 內容 */}
      <DropdownMenuContent side="bottom" align="end" sideOffset={6} className="sm:border-[#EBEEF5] sm:bg-[#FFF] sm:p-0 sm:[&>div]:border-b sm:[&>div:last-child]:border-b-0">
        <DropdownMenuItem
          className="text-13 cursor-pointer px-15 text-[#606266] capitalize hover:opacity-80 sm:border-[#EBEEF5]"
          onClick={() => {
            push(ROUTES.HOME())
          }}>
          {t('B418')}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="text-13 cursor-pointer px-15 text-[#606266] capitalize hover:opacity-80 sm:border-[#EBEEF5]"
          onClick={() => {
            push(ROUTES.UPDATE_PASSWORD())
          }}>
          {t('old:updatePwd')}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="text-13 cursor-pointer px-15 text-[#606266] capitalize hover:opacity-80 sm:border-[#EBEEF5]"
          onClick={() => {
            logout()
          }}>
          {t('B416')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default UserData
